import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./Navbar.scss"

export default function Navbar() {
  const healbid_logo = "/Assets/logo.png";

  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="nav_bar">
      <div className="container">
        <div className="all_nav_flex">

          {/* LEFT LOGO */}
          <div className="lef_t">
            <img src={healbid_logo} alt="logo" />
          </div>

          {/* MOBILE TOGGLE */}
          <div className="menu_toggle" onClick={toggleMenu}>
            {isOpen ? "✖" : "☰"}
          </div>

          {/* MIDDLE MENU */}
          <div className={`mi_d_nav ${isOpen ? "active" : ""}`}>
            <ul className='ankertag'>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/">Hospitals</Link></li>
              <li><Link to="/">Doctors</Link></li>
              <li><Link to="/AboutUs">About us</Link></li>
              <li><Link to="/get-started">Patient Login / Sign up</Link></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

